import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { XMarkIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline';

const WarningDialog = ({
  open,
  onClose,
  onConfirm,
  actionType,
  themeValue,
}) => {
  const getDialogContent = () => {
    switch (actionType) {
      case 'edit':
        return {
          title: 'Clone Combo',
          message:
            'This is a Straico default combo. Would you like to create a copy that you can edit?',
          confirmText: 'Clone',
          icon: DocumentDuplicateIcon,
        };
      default:
        return {
          title: 'Warning',
          message: 'Are you sure you want to proceed?',
          confirmText: 'Confirm',
          icon: XMarkIcon,
        };
    }
  };

  const dialogContent = getDialogContent();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: '21px',
          backgroundColor: themeValue === 'dark' ? '#252425' : '#F7F7F8',
          width: '90%',
          maxWidth: '400px',
          height: 'auto',
          maxHeight: '90vh',
          padding: '16px',
          overflowY: 'auto',
        },
        elevation: 0,
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          color: themeValue === 'dark' ? '#EFEFEF' : '#211E21',
          fontWeight: 700,
          fontSize: '24px',
          fontFamily: 'Figtree',
          lineHeight: '28px',
          '@media (max-width:600px)': {
            fontSize: '20px',
            lineHeight: '24px',
          },
        }}
      >
        {dialogContent.title}
      </DialogTitle>
      <DialogContent
        sx={{
          paddingBottom: '1px',
          fontFamily: 'Figtree',
          textAlign: 'center',
          '@media (max-width:600px)': {
            padding: '12px',
          },
        }}
      >
        {dialogContent.message}
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          marginTop: '8px',
          fontFamily: 'Figtree',
          gap: '22%',
          '@media (max-width:600px)': {
            marginTop: '8px',
            gap: '16px',
            flexWrap: 'wrap',
          },
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            flex: 1,
            backgroundColor: themeValue === 'dark' ? '#3B3B45' : '#D4D5E6',
            color: themeValue === 'dark' ? '#7F82C3' : '#5256A6',
            textTransform: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            '&:hover': {
              backgroundColor: themeValue === 'dark' ? '#34343E' : '#C7C9DE',
            },
            '@media (max-width:600px)': {
              fontSize: '14px',
              padding: '6px 12px',
            },
          }}
        >
          <XMarkIcon className="w-[16px] h-[16px]" />
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          sx={{
            flex: 1,
            backgroundColor: '#464BBA',
            color: '#FFFFFF',
            textTransform: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            '&:hover': {
              backgroundColor: '#3B40A0',
            },
            '@media (max-width:600px)': {
              fontSize: '14px',
              padding: '6px 12px',
            },
          }}
        >
          <dialogContent.icon className="w-[16px] h-[16px]" />
          {dialogContent.confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WarningDialog;
